package com.essntl.features.price.domain.model.proposalserviceprice

import com.essntl.features.price.domain.model.supplierserviceprice.SupplierServicePriceModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel

data class ProposalServicePriceModel(
    val id: String,
    val proposalService: ProposalServiceModel,
    val supplierServicePrice: SupplierServicePriceModel,
    val quantity: Double,
    val explanation: String,
    val createdAt: String,
    val updatedAt: String,
    val total: Double?,
    val isSelected: Boolean?,
    val visibility: Visibility,
    val updatedBy: String?,
) {
    enum class Visibility {
        Hidden,
        Option,
        OnlyOption;

        override fun toString(): String {
            return when (this) {
                Hidden -> "Hidden"
                Option -> "Option"
                OnlyOption -> "Only Option"
            }
        }
    }
}